import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo1.png";
import React from 'react';

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <p>Vist me at my <a href="https://www.linkedin.com/in/mohammad-haseeb-002085233/" target="_blank" rel="noopener noreferrer" color="white">LinkedIn</a> / <a href="https://github.com/MHaseeb02" target="_blank" rel="noopener noreferrer">Github</a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
